// angular
// 	.module("HeroPRO")
// 	.controller("actionItemsController", actionItemsController);


import _ from 'lodash';
import './actionItems.scss';

/* @ngInject */
export default function actionItemsController($scope, $state, $location, ActionItemsFactory, actionItemFiltersFactory, $analytics, UserData, Timestamp, coachmark, $timeout, HPConfig, $window) {
    const vm = this;
    const defaultActionItemParams = {}; // Action item params without any of the filters included
    let actionItemParams = {}; // Complete set of params used to request action items
    vm.loading = false;
    vm.contextMenuIsOpen = false;

    init();

    /*= =======================================
    =            Public Functions            =
    ======================================== */
    vm.contextMenuClick = function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
    };

    vm.contextMenuOpened = function (open) {
        vm.contextMenuIsOpen = open;
    };

    vm.actionItemClick = function (action, fromCallToAction) {
        if (((fromCallToAction === true) || (!vm.contextMenuIsOpen && $window.innerWidth <= HPConfig.screenSizes.screen_md)) && (action.ActionItemStatusId === 1 || action.ActionItemStatusId === 4)) {
            if (action.ActionItemStatusId === 1) {
            	// If the action item has a status of open, set its status to initiated.
            	ActionItemsFactory.setActionItemStatus({
            		ActionItemId: action.ActionItemId,
            		ActionItemStatus: 4,
            	});
            }

            // Google Analytics for action item click. Taking timezone offset into consideration.
            const actionItemClickTime = new Date().getTime() - (new Date(action.WarningDate).getTime() + (new Date().getTimezoneOffset() * 60 * 1000));
            $analytics.eventTrack(`Open:${action.ActionItemTypeName}`, { category: 'ActionItem', label: vm.source, value: actionItemClickTime });

            action.click();
    	}
    };

    vm.dismissActionItem = function (action) {
    	ActionItemsFactory.setActionItemStatus({
    		ActionItemId: action.ActionItemId,
    		ActionItemStatus: 5,
    	});

        action.ActionItemStatusId = 5;
    	action.dismissed = true;
    	$analytics.eventTrack('Dismiss', { category: 'ActionItem', label: vm.source });
    };

    vm.undismissActionItem = function (action, $event) {
    	ActionItemsFactory.setActionItemStatus({
    		ActionItemId: action.ActionItemId,
    		ActionItemStatus: 1,
    	});

        action.ActionItemStatusId = 1;
    	action.dismissed = false;
    	$analytics.eventTrack('UnDismiss', { category: 'ActionItem', label: vm.source });

        $event.preventDefault();
        $event.stopPropagation();
    };
    /* -----  End of Public Functions  ------*/

    /*= ========================================
    =            Private Functions            =
    ========================================= */
    function init() {
    	// If maxActionItems was set on the directive, use that value as the page size
    	if (vm.maxActionItems !== undefined) {
    		defaultActionItemParams.PageNumber = 0;
    		defaultActionItemParams.PageSize = vm.maxActionItems;
    	}

        // Set the params for the initial action items request
        actionItemParams = _.extend({}, defaultActionItemParams, actionItemFiltersFactory.getSelectedActionItemFilters());

    	// Load action items on page load
        UserData.getCurrentLocation().then((location) => {
            setLocationContractorId(location);
	    	getActionItems(actionItemParams);
        });

        // Update action items when the location dropdown is changed
        $scope.$on('HPLocationChange', (event, data) => {
            setLocationContractorId(data);
            getActionItems(actionItemParams);
        });

        // Update action items when filters are changed
        $scope.$watchCollection(actionItemFiltersFactory.getSelectedActionItemFilters, (newFilters, oldFilters) => {
            if (!_.isEqual(newFilters, oldFilters)) {
                getActionItems(_.extend({}, defaultActionItemParams, newFilters));
            }
        });
    }

    function getActionItems(params) {
    	vm.loading = true;
        ActionItemsFactory.getActionItems(params)
            .then((data) => {
            	vm.loading = false;
                vm.actions = data;
                const actionItemsLoadTime = (new Date().getTime() - Timestamp.getTimestamp('stateChangeTimestamp'));
                $analytics.eventTrack('Initialize', { category: 'ActionItem', label: vm.source, value: actionItemsLoadTime });

                // Auto start coachmark tour after the action items have been loaded
                if (vm.source === 'summaryView' && $window.innerWidth >= HPConfig.screenSizes.screen_md) {
                    $timeout(() => {
                        coachmark.startCoachmarkTour(true);
                    });
                }
    		});
    }

    function setLocationContractorId(newLocation) {
    	if (newLocation.ContractorId === '') {
    		delete actionItemParams.ContractorLocationId;
            delete defaultActionItemParams.ContractorLocationId;
    	} else {
            actionItemParams.ContractorLocationId = newLocation.ContractorId;
	    	defaultActionItemParams.ContractorLocationId = newLocation.ContractorId;
    	}
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/actionItems/actionItemsController.js